import React from "react";
import SubscriptionPlanBoxes from "./SubscriptionPlanBoxes";

const CurrentSubscription = React.memo(
   ({
      planName,
      subscriptionStatus,
      subscriptionId,
      price,
      isMonthly,
      subscriptionStartsAt,
      commitmentEnd,
      subscriptionEndsAt,
      cancelAt,
      pendingPlanChange,
      billingManaged,
      onPlanChanged
   }) => {
      return (
         <div className="currentSubscription">
            <SubscriptionPlanBoxes
               planName={planName}
               subscriptionStatus={subscriptionStatus}
               subscriptionId={subscriptionId}
               price={price}
               isMonthly={isMonthly}
               subscriptionStartsAt={subscriptionStartsAt}
               commitmentEnd={commitmentEnd}
               subscriptionEndsAt={subscriptionEndsAt}
               cancelAt={cancelAt}
               pendingPlanChange={pendingPlanChange}
               billingManaged={billingManaged}
               onPlanChanged={onPlanChanged}
            ></SubscriptionPlanBoxes>
         </div>
      );
   }
);

export default CurrentSubscription;
